import { FilterConfig } from '../models/filter-config';
import { ToolkitLayerConfig } from '../models/toolkit-intelligence-config';

export const sidebarFiltersConfig: FilterConfig[] = [
  {
    label: 'Show Commercial Buildings',
    field: 'OCC_CLS',
    options: ['Commercial'],
    selectedValue: '',
  },
  {
    label: 'Show Government Buildings',
    field: 'OCC_CLS',
    options: ['Government'],
    selectedValue: '',
  },
  {
    label: 'Show Educational Buildings',
    field: 'OCC_CLS',
    options: ['Education'],
    selectedValue: '',
  },
  {
    label: 'Show Industrial Buildings',
    field: 'OCC_CLS',
    options: ['Industrial'],
    selectedValue: '',
  },
];

export const toolkitIntelligenceLayers: ToolkitLayerConfig[] = [
  {
    title: 'Environmental Health Hazard Index',
    analysisType: 'Proximity',
    fields: [
      { key: 'OBJECTID', displayName: 'OBJECTID' },
      { key: 'GEOID', displayName: 'GEOID' },
      { key: 'CATEGORY', displayName: 'CATEGORY' },
      { key: 'HAZ_IDX', displayName: 'HAZ_IDX' },
      { key: 'STUSAB', displayName: 'STUSAB' },
      { key: 'STATE', displayName: 'STATE' },
      { key: 'STATE_NAME', displayName: 'STATE_NAME' },
      { key: 'COUNTY', displayName: 'COUNTY' },
      { key: 'COUNTY_NAME', displayName: 'COUNTY_NAME' },
      { key: 'TRACT', displayName: 'TRACT' },
      { key: 'VERSION', displayName: 'VERSION' },
      { key: 'Shape__Area', displayName: 'Shape__Area' },
      { key: 'Shape__Length', displayName: 'Shape__Length' },
    ],
  },
  {
    title: 'Racially or Ethnically Concentrated Areas of Poverty (R/ECAPs)',
    analysisType: 'Proximity',
    fields: [
      { key: 'OBJECTID', displayName: 'OBJECTID' },
      { key: 'GEOID', displayName: 'GEOID' },
      { key: 'STATE', displayName: 'STATE' },
      { key: 'STUSAB', displayName: 'STUSAB' },
      { key: 'STATE_NAME', displayName: 'STATE_NAME' },
      { key: 'COUNTY', displayName: 'COUNTY' },
      { key: 'COUNTY_NAME', displayName: 'COUNTY_NAME' },
      { key: 'CNTY_FIPS', displayName: 'CNTY_FIPS' },
      { key: 'TRACT', displayName: 'TRACT' },
      { key: 'RCAP_90', displayName: 'RCAP_90' },
      { key: 'RCAP_00', displayName: 'RCAP_00' },
      { key: 'RCAP_10', displayName: 'RCAP_10' },
      { key: 'rcap_current', displayName: 'rcap_current' },
      { key: 'Shape__Area', displayName: 'Shape__Area' },
      { key: 'Shape__Length', displayName: 'Shape__Length' },
    ],
  },
  {
    title: 'ACS 5YR Demographic Estimate Data by Tract',
    analysisType: 'Proximity',
    fields: [
      { key: 'OBJECTID', displayName: 'Object ID' },
      { key: 'GEOID', displayName: 'Geographic ID' },
      { key: 'STATE', displayName: 'State Code' },
      { key: 'STUSAB', displayName: 'State Abbreviation' },
      { key: 'COUNTY', displayName: 'County Code' },
      { key: 'TRACT', displayName: 'Census Tract' },
      { key: 'NAME', displayName: 'Name' },
      { key: 'CNTY_FIPS', displayName: 'County FIPS Code' },
      { key: 'EACODE', displayName: 'Economic Area Code' },
      { key: 'EANAME', displayName: 'Economic Area Name' },
      { key: 'B03002EST1', displayName: 'Total Population' },
      { key: 'B01001_UNDER17', displayName: 'Population Age 0-17' },
      { key: 'B01001_UNDER17_PCT', displayName: 'Population Age 0-17 as %' },
      { key: 'B01001_18TO24', displayName: 'Population Age 18-24' },
      { key: 'B01001_18TO24_PCT', displayName: 'Population Age 18-24 as %' },
      { key: 'B01001_25TO64', displayName: 'Population Age 25-64' },
      { key: 'B01001_25TO64_PCT', displayName: 'Population Age 25-64 as %' },
      { key: 'B01001_ABOVE64', displayName: 'Population Age 65 and Over' },
      {
        key: 'B01001_ABOVE64_PCT',
        displayName: 'Population Age 65 and Over as %',
      },
      { key: 'B03002EST3', displayName: 'White alone (not Hispanic)' },
      { key: 'B03002EST3_PCT', displayName: 'White alone (not Hispanic) as %' },
      {
        key: 'B03002EST4',
        displayName: 'Black or African American alone (not Hispanic)',
      },
      {
        key: 'B03002EST4_PCT',
        displayName: 'Black or African American alone (not Hispanic) as %',
      },
      {
        key: 'B03002EST5',
        displayName: 'American Indian and Alaska Native alone (not Hispanic)',
      },
      {
        key: 'B03002EST5_PCT',
        displayName:
          'American Indian and Alaska Native alone (not Hispanic) as %',
      },
      { key: 'B03002EST6', displayName: 'Asian alone (not Hispanic)' },
      { key: 'B03002EST6_PCT', displayName: 'Asian alone (not Hispanic) as %' },
      {
        key: 'B03002EST7',
        displayName:
          'Native Hawaiian and Other Pacific Islander alone (not Hispanic)',
      },
      {
        key: 'B03002EST7_PCT',
        displayName:
          'Native Hawaiian and Other Pacific Islander alone (not Hispanic) as %',
      },
      {
        key: 'B03002EST8',
        displayName: 'Some Other Race alone (not Hispanic)',
      },
      {
        key: 'B03002EST8_PCT',
        displayName: 'Some Other Race alone (not Hispanic) as %',
      },
      { key: 'B03002TMNH', displayName: 'Two or More Races (not Hispanic)' },
      {
        key: 'B03002TMNH_PCT',
        displayName: 'Two or More Races (not Hispanic) as %',
      },
      { key: 'B03002EST12', displayName: 'Persons of Hispanic Origin' },
      {
        key: 'B03002EST12_PCT',
        displayName: 'Persons of Hispanic Origin as %',
      },
      { key: 'B11005EST1', displayName: 'Total Households' },
      {
        key: 'B11005EST2',
        displayName: 'Households with one or more people under 18 years',
      },
      {
        key: 'B11005EST2_PCT',
        displayName: 'Households with one or more people under 18 years as %',
      },
      {
        key: 'B11006EST2',
        displayName: 'Households with one or more people 60 years and Over',
      },
      {
        key: 'B11006EST2_PCT',
        displayName:
          'Households with one or more people 60 years and Over as %',
      },
      { key: 'B11001EST8', displayName: 'Households living alone' },
      { key: 'B11001EST8_PCT', displayName: 'Households living alone as %' },
      {
        key: 'B16005EST1',
        displayName: 'Universe of Population 5 Years and Over',
      },
      {
        key: 'B16005NE',
        displayName:
          'Population 5 years and over that speak English "not at all"',
      },
      {
        key: 'B16005NE_PCT',
        displayName:
          'Population 5 years and over that speak English "not at all" as %',
      },
      {
        key: 'B25010EST1',
        displayName: 'Average Household Size of occupied Housing Units',
      },
      {
        key: 'B25010EST2',
        displayName: 'Average Household Size of Owner occupied Housing Units',
      },
      {
        key: 'B25010EST3',
        displayName: 'Average Household Size of Renter occupied Housing Units',
      },
      { key: 'B15001EST1', displayName: 'Total Population 18 Years and Over' },
      { key: 'AGE_18TO24', displayName: 'Population Ages 18 to 24' },
      { key: 'AGE_25TO34', displayName: 'Population Ages 25 to 34' },
      { key: 'AGE_35TO44', displayName: 'Population Ages 35 to 44' },
      { key: 'AGE_45TO64', displayName: 'Population Ages 45 to 64' },
      { key: 'AGE_65UP', displayName: 'Population Ages 65 and Older' },
      {
        key: 'LT9_18TO24',
        displayName:
          'Population Ages 18 to 24 having less than High School Education',
      },
      {
        key: 'LT9_18TO24_PCT',
        displayName:
          'Population Ages 18 to 24 having less than High School Education as %',
      },
      {
        key: 'HSND_18TO24',
        displayName:
          'Population Ages 18 to 24 having some High School Education (No Diploma)',
      },
      {
        key: 'HSND_18TO24_PCT',
        displayName:
          'Population Ages 18 to 24 having some High School Education (No Diploma) as %',
      },
      {
        key: 'HS_18TO24',
        displayName: 'Population Ages 18 to 24 having High School Education',
      },
      {
        key: 'HS_18TO24_PCT',
        displayName:
          'Population Ages 18 to 24 having High School Education as %',
      },
      {
        key: 'CND_18TO24',
        displayName:
          'Population Ages 18 to 24 having some College Education (No Degree)',
      },
      {
        key: 'CND_18TO24_PCT',
        displayName:
          'Population Ages 18 to 24 having some College Education (No Degree) as %',
      },
      {
        key: 'AD_18TO24',
        displayName: "Population Ages 18 to 24 having Associate's Degree",
      },
      {
        key: 'AD_18TO24_PCT',
        displayName: "Population Ages 18 to 24 having Associate's Degree as %",
      },
      {
        key: 'BD_18TO24',
        displayName: "Population Ages 18 to 24 having Bachelor's Degree",
      },
      {
        key: 'BD_18TO24_PCT',
        displayName: "Population Ages 18 to 24 having Bachelor's Degree as %",
      },
      {
        key: 'GD_18TO24',
        displayName: 'Population Ages 18 to 24 having Graduate Degree',
      },
      {
        key: 'GD_18TO24_PCT',
        displayName: 'Population Ages 18 to 24 having Graduate Degree as %',
      },
      {
        key: 'LT9_25TO34',
        displayName:
          'Population Ages 25 to 34 having less than High School Education',
      },
      {
        key: 'LT9_25TO34_PCT',
        displayName:
          'Population Ages 25 to 34 having less than High School Education as %',
      },
      {
        key: 'HSND_25TO34',
        displayName:
          'Population Ages 25 to 34 having some High School Education (No Diploma)',
      },
      {
        key: 'HSND_25TO34_PCT',
        displayName:
          'Population Ages 25 to 34 having some High School Education (No Diploma) as %',
      },
      {
        key: 'HS_25TO34',
        displayName: 'Population Ages 25 to 34 having High School Education',
      },
      {
        key: 'HS_25TO34_PCT',
        displayName:
          'Population Ages 25 to 34 having High School Education as %',
      },
      {
        key: 'CND_25TO34',
        displayName:
          'Population Ages 25 to 34 having some College Education (No Degree)',
      },
      {
        key: 'CND_25TO34_PCT',
        displayName:
          'Population Ages 25 to 34 having some College Education (No Degree) as %',
      },
      {
        key: 'AD_25TO34',
        displayName: "Population Ages 25 to 34 having Associate's Degree",
      },
      {
        key: 'AD_25TO34_PCT',
        displayName: "Population Ages 25 to 34 having Associate's Degree as %",
      },
      {
        key: 'BD_25TO34',
        displayName: "Population Ages 25 to 34 having Bachelor's Degree",
      },
      {
        key: 'BD_25TO34_PCT',
        displayName: "Population Ages 25 to 34 having Bachelor's Degree as %",
      },
      {
        key: 'GD_25TO34',
        displayName: 'Population Ages 25 to 34 having Graduate Degree',
      },
      {
        key: 'GD_25TO34_PCT',
        displayName: 'Population Ages 25 to 34 having Graduate Degree as %',
      },
      {
        key: 'LT9_35TO44',
        displayName:
          'Population Ages 35 to 44 having less than High School Education',
      },
      {
        key: 'LT9_35TO44_PCT',
        displayName:
          'Population Ages 35 to 44 having less than High School Education as %',
      },
      {
        key: 'HSND_35TO44',
        displayName:
          'Population Ages 35 to 44 having some High School Education (No Diploma)',
      },
      {
        key: 'HSND_35TO44_PCT',
        displayName:
          'Population Ages 35 to 44 having some High School Education (No Diploma) as %',
      },
      {
        key: 'HS_35TO44',
        displayName: 'Population Ages 35 to 44 having High School Education',
      },
      {
        key: 'HS_35TO44_PCT',
        displayName:
          'Population Ages 35 to 44 having High School Education as %',
      },
      {
        key: 'CND_35TO44',
        displayName:
          'Population Ages 35 to 44 having some College Education (No Degree)',
      },
      {
        key: 'CND_35TO44_PCT',
        displayName:
          'Population Ages 35 to 44 having some College Education (No Degree) as %',
      },
      {
        key: 'AD_35TO44',
        displayName: "Population Ages 35 to 44 having Associate's Degree",
      },
      {
        key: 'AD_35TO44_PCT',
        displayName: "Population Ages 35 to 44 having Associate's Degree as %",
      },
      {
        key: 'BD_35TO44',
        displayName: "Population Ages 35 to 44 having Bachelor's Degree",
      },
      {
        key: 'BD_35TO44_PCT',
        displayName: "Population Ages 35 to 44 having Bachelor's Degree as %",
      },
      {
        key: 'GD_35TO44',
        displayName: 'Population Ages 35 to 44 having Graduate Degree',
      },
      {
        key: 'GD_35TO44_PCT',
        displayName: 'Population Ages 35 to 44 having Graduate Degree as %',
      },
      {
        key: 'LT9_45TO64',
        displayName:
          'Population Ages 45 to 64 having less than High School Education',
      },
      {
        key: 'LT9_45TO64_PCT',
        displayName:
          'Population Ages 45 to 64 having less than High School Education as %',
      },
      {
        key: 'HSND_45TO64',
        displayName:
          'Population Ages 45 to 64 having some High School Education (No Diploma)',
      },
      {
        key: 'HSND_45TO64_PCT',
        displayName:
          'Population Ages 45 to 64 having some High School Education (No Diploma) as %',
      },
      {
        key: 'HS_45TO64',
        displayName: 'Population Ages 45 to 64 having High School Education',
      },
      {
        key: 'HS_45TO64_PCT',
        displayName:
          'Population Ages 45 to 64 having High School Education as %',
      },
      {
        key: 'CND_45TO64',
        displayName:
          'Population Ages 45 to 64 having some College Education (No Degree)',
      },
      {
        key: 'CND_45TO64_PCT',
        displayName:
          'Population Ages 45 to 64 having some College Education (No Degree) as %',
      },
      {
        key: 'AD_45TO64',
        displayName: "Population Ages 45 to 64 having Associate's Degree",
      },
      {
        key: 'AD_45TO64_PCT',
        displayName: "Population Ages 45 to 64 having Associate's Degree as %",
      },
      {
        key: 'BD_45TO64',
        displayName: "Population Ages 45 to 64 having Bachelor's Degree",
      },
      {
        key: 'BD_45TO64_PCT',
        displayName: "Population Ages 45 to 64 having Bachelor's Degree as %",
      },
      {
        key: 'GD_45TO64',
        displayName: 'Population Ages 45 to 64 having Graduate Degree',
      },
      {
        key: 'GD_45TO64_PCT',
        displayName: 'Population Ages 45 to 64 having Graduate Degree as %',
      },
      {
        key: 'LT9_65UP',
        displayName:
          'Population Ages 65 and Older having less than High School Education',
      },
      {
        key: 'LT9_65UP_PCT',
        displayName:
          'Population Ages 65 and Older having less than High School Education as %',
      },
      {
        key: 'HSND_65UP',
        displayName:
          'Population Ages 65 and Older having some High School Education (No Diploma)',
      },
      {
        key: 'HSND_65UP_PCT',
        displayName:
          'Population Ages 65 and Older having some High School Education (No Diploma) as %',
      },
      {
        key: 'HS_65UP',
        displayName:
          'Population Ages 65 and Older having High School Education',
      },
      {
        key: 'HS_65UP_PCT',
        displayName:
          'Population Ages 65 and Older having High School Education as %',
      },
      {
        key: 'CND_65UP',
        displayName:
          'Population Ages 65 and Older having some College Education (No Degree)',
      },
      {
        key: 'CND_65UP_PCT',
        displayName:
          'Population Ages 65 and Older having some College Education (No Degree) as %',
      },
      {
        key: 'AD_65UP',
        displayName: "Population Ages 65 and Older having Associate's Degree",
      },
      {
        key: 'AD_65UP_PCT',
        displayName:
          "Population Ages 65 and Older having Associate's Degree as %",
      },
      {
        key: 'BD_65UP',
        displayName: "Population Ages 65 and Older having Bachelor's Degree",
      },
      {
        key: 'BD_65UP_PCT',
        displayName:
          "Population Ages 65 and Older having Bachelor's Degree as %",
      },
      {
        key: 'GD_65UP',
        displayName: 'Population Ages 65 and Older having Graduate Degree',
      },
      {
        key: 'GD_65UP_PCT',
        displayName: 'Population Ages 65 and Older having Graduate Degree as %',
      },
      { key: 'Shape__Area', displayName: 'Shape Area' },
      { key: 'Shape__Length', displayName: 'Shape Length' },
    ],
  },
  {
    title: 'DSIRE Summary of Programs',
    analysisType: 'Proximity',
    fields: [
      { key: 'fips', displayName: 'FIPS' },
      { key: 'state', displayName: 'State' },
      { key: 'county', displayName: 'County' },
      { key: 'arc', displayName: 'ARC' },
      { key: 'county_state', displayName: 'County State' },
      { key: 'program_name', displayName: 'Program Name' },
      { key: 'code', displayName: 'Code' },
      { key: 'state_info_intro', displayName: 'State Info Intro' },
      { key: 'state_info_history', displayName: 'State Info History' },
      {
        key: 'renewable_portfolio_standard',
        displayName: 'Renewable Portfolio Standard',
      },
      { key: 'program_summary', displayName: 'Program Summary' },
      { key: 'SHAPE__Area', displayName: 'Shape Area' },
      { key: 'SHAPE__Length', displayName: 'Shape Length' },
    ],
  },
  {
    title: 'Difficult Development Areas',
    analysisType: 'Proximity',
    fields: [
      { key: 'OBJECTID', displayName: 'Object ID' },
      { key: 'ZCTA5', displayName: 'Zip Code Tabulation Area Code' },
      { key: 'DDA_CODE', displayName: 'Difficult Development Area Code' },
      { key: 'DDA_TYPE', displayName: 'Difficult Development Area Type' },
      { key: 'DDA_NAME', displayName: 'Difficult Development Area Name' },
      { key: 'Shape__Area', displayName: 'Shape__Area' },
      { key: 'Shape__Length', displayName: 'Shape__Length' },
    ],
  },
  {
    title: 'USA Flood Hazards',
    analysisType: 'Proximity',
  },
  {
    title: 'EPA_IRA_LIDAC',
    analysisType: 'Proximity',
  },
  {
    title: 'New Market Tax Credit 2020',
    analysisType: 'Proximity',
  },
  // {
  //   title: 'Low to Moderate Income Population by Block Group',
  //   analysisType: 'Proximity',
  //   fields: [
  //     { key: 'OBJECTID', displayName: 'OBJECTID' },
  //     { key: 'GEOID', displayName: 'GEOID' },
  //     { key: 'Source', displayName: 'Source' },
  //     { key: 'geoname', displayName: 'geoname' },
  //     { key: 'Stusab', displayName: 'Stusab' },
  //     { key: 'Countyname', displayName: 'Countyname' },
  //     { key: 'State', displayName: 'State' },
  //     { key: 'County', displayName: 'County' },
  //     { key: 'Tract', displayName: 'Tract' },
  //     { key: 'BLKGRP', displayName: 'BLKGRP' },
  //     { key: 'Low', displayName: 'Low' },
  //     { key: 'Lowmod', displayName: 'Lowmod' },
  //     { key: 'Lmmi', displayName: 'Lmmi' },
  //     { key: 'Lowmoduniv', displayName: 'Lowmoduniv' },
  //     { key: 'Lowmod_pct', displayName: 'Lowmod_pct' },
  //     { key: 'uclow', displayName: 'uclow' },
  //     { key: 'uclowmod', displayName: 'uclowmod' },
  //     { key: 'ucLowmod_p', displayName: 'ucLowmod_p' },
  //     { key: 'MOE_LOWMOD_PCT', displayName: 'MOE_LOWMOD_PCT' },
  //     { key: 'MOE_UCLOWMOD_PCT', displayName: 'MOE_UCLOWMOD_PCT' },
  //     { key: 'Shape__Area', displayName: 'Shape__Area' },
  //     { key: 'Shape__Length', displayName: 'Shape__Length' },
  //   ],
  // },
  {
    title: 'Low to Moderate Income Population by Tract',
    analysisType: 'Proximity',
    fields: [
      { key: 'OBJECTID', displayName: 'OBJECTID' },
      { key: 'GEOID', displayName: 'GEOID' },
      { key: 'STATE', displayName: 'STATE' },
      { key: 'COUNTY', displayName: 'COUNTY' },
      { key: 'TRACT', displayName: 'TRACT' },
      { key: 'LOWMOD', displayName: 'LOWMOD' },
      { key: 'LOWMODUNIV', displayName: 'LOWMODUNIV' },
      { key: 'LOWMODPCT', displayName: 'Low-Mode Income Percentage' },
      { key: 'UCLMOD', displayName: 'UCLMOD' },
      { key: 'UCLMODU', displayName: 'UCLMODU' },
      { key: 'UCLMODPCT', displayName: 'UCLMODPCT' },
      { key: 'Shape__Area', displayName: 'Shape__Area' },
      { key: 'Shape__Length', displayName: 'Shape__Length' },
    ],
  },
  {
    title: 'USA Structures',
    analysisType: 'Proximity',
  },
  {
    title: 'Opportunity Zones',
    analysisType: 'Closest Feature',
    fields: [
      { key: 'OBJECTID', displayName: 'OBJECTID' },
      { key: 'GEOID10', displayName: 'GEOID10' },
      { key: 'STATE', displayName: 'STATE' },
      { key: 'COUNTY', displayName: 'COUNTY' },
      { key: 'TRACT', displayName: 'TRACT' },
      { key: 'STUSAB', displayName: 'STUSAB' },
      { key: 'STATE_NAME', displayName: 'STATE_NAME' },
      { key: 'Shape__Area', displayName: 'Shape__Area' },
      { key: 'Shape__Length', displayName: 'Shape__Length' },
    ],
  },
  {
    title: 'CDFI Investment Areas',
    analysisType: 'Proximity',
    fields: [
      { key: 'ia2020', displayName: 'CDFI Investment Area' },
      { key: 'POPULATION_2022', displayName: '2022 Population' },
      // { key: 'OBJECTID', displayName: 'Object ID' },
      { key: 'STATE_ABBR', displayName: 'State' },
      // { key: 'STATE_FIPS', displayName: 'State FIPS' },
      // { key: 'COUNTY_FIPS', displayName: 'County FIPS' },
      // { key: 'STCOFIPS', displayName: 'State County FIPS' },
      // { key: 'TRACT_FIPS', displayName: 'Tract FIPS' },
      // { key: 'FIPS', displayName: 'FIPS' },
      // { key: 'POP22_SQMI', displayName: 'Population 2022 per Square Mile' },
      // { key: 'SQMI', displayName: 'Square Miles' },
      // { key: 'POPULATION_2020', displayName: 'Population 2020' },
      // { key: 'POP20_SQMI', displayName: 'Population 2020 per Square Mile' },
      // { key: 'ct2020', displayName: 'ct2020' },
      // { key: 'statename2020', displayName: 'State Name 2020' },
      // { key: 'countyname2020', displayName: 'County Name 2020' },
      // { key: 'cbsa2020_ind', displayName: 'cbsa2020_ind' },
      // { key: 'pop_total2020', displayName: 'Total Population 2020' },
      // { key: 'pov2020___', displayName: 'pov2020(%)' },
      // { key: 'pov2020_ind', displayName: 'pov2020_ind' },
      // { key: 'mfi2020', displayName: 'Median Family Income 2020' },
      // { key: 'mfi2020_cbsa', displayName: 'MFI 2020 CBSA' },
      // { key: 'mfi2020_metro_nat', displayName: 'MFI 2020 Metro National' },
      // { key: 'mfi2020_nonmetro_st', displayName: 'MFI 2020 Non-Metro State' },
      // {
      //   key: 'mfi2020_nonmetro_nat',
      //   displayName: 'MFI 2020 Non-Metro National',
      // },
      // { key: 'mfi2020_shr___', displayName: 'mfi2020_shr(%)' },
      {
        key: 'mfi2020_ind',
        displayName:
          'If the share of median family income is at or below 80 percent, then it is eligible.',
      },
      // { key: 'u2020___', displayName: 'u2020(%)' },
      {
        key: 'u2020_ind',
        displayName:
          'If the unemployment rate ratio is at least 1.5, then it is eligible.',
      },
      // { key: 'u2020_r', displayName: 'Unemployment 2020 Rate' },
      {
        key: 'zone_empower2020_ind',
        displayName:
          'If the Census tract is wholly located within an Empowerment Zone or Enterprise Community, then it is eligible.',
      },
      // { key: 'pop_r___', displayName: 'pop_r(%)' },
      {
        key: 'pop_loss2020_ind',
        displayName:
          'If the Census tract located in a county with population loss greater than or equal to ten percent for Metro areas or five percent for Non-Metro areas, then it is eligible.',
      },
      // { key: 'Shape_Length', displayName: 'Shape Length' },
      // { key: 'Shape_Area', displayName: 'Shape Area' },
    ],
  },
  {
    title: 'Regrid Nationwide Parcel Data',
    analysisType: 'Closest Feature',
    fields: [
      { key: 'id', displayName: 'id' },
      { key: 'ogc_fid', displayName: 'Object ID' },
      { key: 'geoid', displayName: 'FIPS Code' },
      { key: 'parcelnumb', displayName: 'Parcel ID' },
      {
        key: 'parcelnumb_no_formatting',
        displayName: 'Parcel ID without Formatting',
      },
      {
        key: 'state_parcelnumb',
        displayName: 'State Provided Parcel ID Number',
      },
      { key: 'account_number', displayName: 'Parcel Account Number' },
      { key: 'tax_id', displayName: 'Parcel Tax Identification Number' },
      { key: 'alt_parcelnumb1', displayName: 'First Alternative Parcel ID' },
      { key: 'alt_parcelnumb2', displayName: 'Second Alternative Parcel ID' },
      { key: 'alt_parcelnumb3', displayName: 'Third Alternative Parcel ID' },
      { key: 'usecode', displayName: 'Parcel Use Code' },
      { key: 'usedesc', displayName: 'Parcel Use Description' },
      { key: 'zoning', displayName: 'Zoning Code' },
      { key: 'zoning_description', displayName: 'Zoning Description' },
      { key: 'zoning_type', displayName: 'Zoning Type' },
      { key: 'zoning_subtype', displayName: 'Zoning Subtype' },
      { key: 'zoning_code_link', displayName: 'Zoning Code Link' },
      { key: 'zoning_id', displayName: 'Zoning Area ID' },
      { key: 'struct', displayName: 'Structure on Parcel' },
      { key: 'structno', displayName: 'Number of Structures on Parcel' },
      { key: 'yearbuilt', displayName: 'Structure Year Built' },
      { key: 'numstories', displayName: 'Number of Stories' },
      { key: 'numunits', displayName: 'Number of Living Units' },
      { key: 'numrooms', displayName: 'Number of Rooms' },
      { key: 'structstyle', displayName: 'Structure Style' },
      { key: 'parvaltype', displayName: 'Parcel Value Type' },
      { key: 'improvval', displayName: 'Improvement Value' },
      { key: 'landval', displayName: 'Land Value' },
      { key: 'parval', displayName: 'Total Parcel Value' },
      { key: 'agval', displayName: 'Agricultural Value' },
      { key: 'homestead_exemption', displayName: 'Homestead Exemption' },
      { key: 'saleprice', displayName: 'Last Sale Price' },
      { key: 'saledate', displayName: 'Last Sale Date' },
      { key: 'taxamt', displayName: 'Annual Tax Bill' },
      { key: 'taxyear', displayName: 'Tax Year' },
      { key: 'owntype', displayName: 'Owner Type' },
      { key: 'owner', displayName: 'Owner Name' },
      { key: 'unmodified_owner', displayName: 'Unmodified Owner Name' },
      { key: 'ownfrst', displayName: 'Owner First Name' },
      { key: 'ownlast', displayName: 'Owner Last Name' },
      { key: 'owner2', displayName: 'Second Owner Name' },
      { key: 'owner3', displayName: 'Third Owner Name' },
      { key: 'owner4', displayName: 'Fourth Owner Name' },
      { key: 'previous_owner', displayName: 'Previous Owner Name' },
      { key: 'mailadd', displayName: 'Mailing Address' },
      { key: 'mail_address2', displayName: 'Mailing Address Second Line' },
      { key: 'careof', displayName: 'Mailing Address Care Of' },
      { key: 'mail_addno', displayName: 'Mailing Address Street Number' },
      { key: 'mail_addpref', displayName: 'Mailing Address Street Prefix' },
      { key: 'mail_addstr', displayName: 'Mailing Address Street Name' },
      { key: 'mail_addsttyp', displayName: 'Mailing Address Street Type' },
      { key: 'mail_addstsuf', displayName: 'Mailing Address Street Suffix' },
      { key: 'mail_unit', displayName: 'Mailing Address Unit Number' },
      { key: 'mail_city', displayName: 'Mailing Address City' },
      { key: 'mail_state2', displayName: 'Mailing Address State' },
      { key: 'mail_zip', displayName: 'Mailing Address ZIP Code' },
      { key: 'mail_country', displayName: 'Mailing Address Country' },
      {
        key: 'mail_urbanization',
        displayName: 'Mailing Address Urbanizacion (Puerto Rico)',
      },
      {
        key: 'original_mailing_address',
        displayName: 'Original Mailing Address',
      },
      { key: 'address', displayName: 'Parcel Address' },
      { key: 'address2', displayName: 'Parcel Address Second Line' },
      { key: 'saddno', displayName: 'Parcel Address Number' },
      { key: 'saddpref', displayName: 'Parcel Address Prefix' },
      { key: 'saddstr', displayName: 'Parcel Address Street Name' },
      { key: 'saddsttyp', displayName: 'Parcel Address Street Type' },
      { key: 'saddstsuf', displayName: 'Parcel Address Street Suffix' },
      { key: 'sunit', displayName: 'Parcel Address Unit' },
      { key: 'scity', displayName: 'Parcel Address City' },
      { key: 'original_address', displayName: 'Original Parcel Address' },
      { key: 'city', displayName: 'US Census County Subdivision' },
      { key: 'county', displayName: 'Parcel Address County' },
      { key: 'state2', displayName: 'Parcel Address State' },
      { key: 'szip', displayName: 'Parcel Address Zip Code' },
      { key: 'szip5', displayName: '5 Digit Parcel Zip Code' },
      { key: 'urbanization', displayName: 'Parcel Urbanizacion' },
      {
        key: 'll_address_count',
        displayName: 'Regrid Calculated Total Address Count',
      },
      { key: 'location_name', displayName: 'Location Name' },
      { key: 'address_source', displayName: 'Primary Address Source' },
      { key: 'legaldesc', displayName: 'Legal Description' },
      { key: 'plat', displayName: 'Plat' },
      { key: 'book', displayName: 'Book' },
      { key: 'page', displayName: 'Page' },
      { key: 'block', displayName: 'Block' },
      { key: 'lot', displayName: 'Lot' },
      { key: 'neighborhood', displayName: 'Neighborhood' },
      { key: 'neighborhood_code', displayName: 'Neighborhood Code' },
      { key: 'subdivision', displayName: 'Subdivision' },
      { key: 'lat', displayName: 'Latitude' },
      { key: 'lon', displayName: 'Longitude' },
      { key: 'fema_flood_zone', displayName: 'FEMA Flood Zone' },
      {
        key: 'fema_flood_zone_subtype',
        displayName: 'FEMA Flood Zone Subtype',
      },
      { key: 'fema_flood_zone_raw', displayName: 'FEMA Flood Zone Raw Data' },
      {
        key: 'fema_flood_zone_data_date',
        displayName: 'FEMA Flood Zone Data Date',
      },
      { key: 'fema_nri_risk_rating', displayName: 'FEMA NRI Risk Rating' },
      { key: 'qoz', displayName: 'Federal Qualified Opportunity Zone' },
      {
        key: 'qoz_tract',
        displayName: 'Qualified Opportunity Zone Tract Number',
      },
      { key: 'census_tract', displayName: 'Census 2020 Tract' },
      { key: 'census_block', displayName: 'Census 2020 Block' },
      { key: 'census_blockgroup', displayName: 'Census 2020 Blockgroup' },
      { key: 'census_zcta', displayName: 'Census Zip Code Tabulation Area' },
      {
        key: 'census_elementary_school_district',
        displayName: 'Census Provided Elementary School District',
      },
      {
        key: 'census_secondary_school_district',
        displayName: 'Census Provided Secondary School District',
      },
      {
        key: 'census_unified_school_district',
        displayName: 'Census Provided Unified School District',
      },
      { key: 'll_last_refresh', displayName: 'Last County Refresh Date' },
      { key: 'sourceurl', displayName: 'Source URL' },
      { key: 'recrdareatx', displayName: 'Recorded Area (text)' },
      { key: 'recrdareano', displayName: 'Total Square Footage of Structures' },
      { key: 'deeded_acres', displayName: 'Deeded Acres' },
      { key: 'gisacre', displayName: 'County-Provided Acres' },
      { key: 'sqft', displayName: 'County-Provided Parcel Square Feet' },
      { key: 'll_gisacre', displayName: 'Regrid Calculated Parcel Acres' },
      {
        key: 'll_gissqft',
        displayName: 'Regrid Calculated Parcel Square Feet',
      },
      {
        key: 'll_bldg_footprint_sqft',
        displayName: 'Regrid Calculated Building Footprint Square Feet',
      },
      { key: 'll_bldg_count', displayName: 'Regrid Calculated Building Count' },
      { key: 'cdl_raw', displayName: 'Cropland Data Layer Raw Values' },
      {
        key: 'cdl_majority_category',
        displayName: 'Cropland Data Layer Majority Category',
      },
      {
        key: 'cdl_majority_percent',
        displayName: 'Cropland Data Layer Majority Percent',
      },
      { key: 'cdl_date', displayName: 'Cropland Data Layer Date' },
      { key: 'plss_township', displayName: 'PLSS Township' },
      { key: 'plss_section', displayName: 'PLSS Section' },
      { key: 'plss_range', displayName: 'PLSS Range' },
      { key: 'reviseddate', displayName: 'Date of Last Revision' },
      { key: 'path', displayName: 'Parcel Path' },
      { key: 'll_stable_id', displayName: 'Stable ID Status' },
      { key: 'll_uuid', displayName: 'Regrid UUID' },
      { key: 'll_stack_uuid', displayName: 'Parcel Stack UUID' },
      { key: 'll_row_parcel', displayName: 'Regrid Right-of-Way Parcel Flag' },
      { key: 'll_updated_at', displayName: 'Last Modified' },
      { key: 'precisely_id', displayName: 'Precisely ID' },
      { key: 'placekey', displayName: 'Placekey' },
      { key: 'dpv_status', displayName: 'USPS Delivery Point Validation' },
      { key: 'dpv_codes', displayName: 'Delivery Point Validation Codes' },
      { key: 'dpv_notes', displayName: 'Delivery Point Validation Notes' },
      { key: 'dpv_type', displayName: 'Delivery Point Match Type' },
      { key: 'cass_errorno', displayName: 'CASS Error Codes' },
      { key: 'rdi', displayName: 'Residential Delivery Indicator' },
      { key: 'usps_vacancy', displayName: 'USPS Vacancy Indicator' },
      { key: 'usps_vacancy_date', displayName: 'USPS Vacancy Indicator Date' },
      {
        key: 'padus_public_access',
        displayName: 'PAD-US Public Access Designation',
      },
      { key: 'lbcs_activity', displayName: 'Land Use Code: Activity' },
      {
        key: 'lbcs_activity_desc',
        displayName: 'Land Use Code Description: Activity',
      },
      { key: 'lbcs_function', displayName: 'Land Use Code: Function' },
      {
        key: 'lbcs_function_desc',
        displayName: 'Land Use Code Description: Function',
      },
      { key: 'lbcs_structure', displayName: 'Land Use Code: Structure' },
      {
        key: 'lbcs_structure_desc',
        displayName: 'Land Use Code Description: Structure',
      },
      { key: 'lbcs_site', displayName: 'Land Use Code: Site' },
      { key: 'lbcs_site_desc', displayName: 'Land Use Code Description: Site' },
      { key: 'lbcs_ownership', displayName: 'Land Use Code: Ownership' },
      {
        key: 'lbcs_ownership_desc',
        displayName: 'Land Use Code Description: Ownership',
      },
      {
        key: 'housing_affordability_index',
        displayName: 'Housing Affordability Index',
      },
      { key: 'population_density', displayName: 'Population Density' },
      {
        key: 'population_growth_past_5_years',
        displayName: 'Population Growth (CAGR) past 5 years',
      },
      {
        key: 'population_growth_next_5_years',
        displayName: 'Population Growth (CAGR) next 5 years',
      },
      {
        key: 'housing_growth_past_5_years',
        displayName: 'Housing Units Growth (CAGR) past 5 years',
      },
      {
        key: 'housing_growth_next_5_years',
        displayName: 'Housing Units Growth (CAGR) next 5 years',
      },
      {
        key: 'household_income_growth_next_5_years',
        displayName: 'Median Household Income Growth (CAGR) next 5 years',
      },
      {
        key: 'median_household_income',
        displayName: 'Median Household Income (current year)',
      },
      {
        key: 'transmission_line_distance',
        displayName: 'Distance to Transmission line',
      },
      { key: 'roughness_rating', displayName: 'Roughness Rating' },
      {
        key: 'highest_parcel_elevation',
        displayName: 'Highest Parcel Elevation',
      },
      {
        key: 'lowest_parcel_elevation',
        displayName: 'Lowest Parcel Elevation',
      },
    ],
  },
  {
    title: 'Rural Designations',
    analysisType: 'Proximity',
    subLayers: [
      {
        title: 'OMB NonMetropolitan Rural Areas',
        analysisType: 'Proximity',
        fields: [
          { key: 'name', displayName: 'County name' },
          { key: 'sqmi', displayName: 'Area in square miles' },
          { key: 'county_fips', displayName: 'County FIPS' },
          { key: 'county_name', displayName: 'County_Name' },
          { key: 'description', displayName: 'Description' },
          { key: 'final_fips', displayName: 'final_fips' },
          { key: 'fips', displayName: 'FIPS' },
          { key: 'fips_1', displayName: 'FIPS' },
          { key: 'population', displayName: 'Population 2020' },
          {
            key: 'pop_sqmi',
            displayName: 'Population Density by square miles',
          },
          { key: 'population_2020', displayName: 'Population_2020' },
          { key: 'rucc_2023', displayName: 'RUCC_2023' },
          { key: 'shape__area', displayName: 'SHAPE__Area' },
          { key: 'shape__length', displayName: 'SHAPE__Length' },
          { key: 'state', displayName: 'State' },
          { key: 'state_abbr', displayName: 'State abbreviation' },
          { key: 'state_fips', displayName: 'State FIPS' },
          { key: 'state_name', displayName: 'State name' },
        ],
      },
      {
        title: 'Priority Energy Communities Rural Areas',
        analysisType: 'Proximity',
        fields: [
          { key: 'name', displayName: 'NAME' },
          { key: 'blsa', displayName: 'BLSA' },
          { key: 'county_fip', displayName: 'COUNTY_FIP' },
          { key: 'fips', displayName: 'FIPS' },
          { key: 'name_full', displayName: 'NAME_FULL' },
          { key: 'shape__area', displayName: 'SHAPE__Area' },
          { key: 'shape__length', displayName: 'SHAPE__Length' },
          { key: 'state_abbr', displayName: 'STATE_ABBR' },
          { key: 'state_fips', displayName: 'STATE_FIPS' },
          { key: 'state_name', displayName: 'STATE_NAME' },
        ],
      },
      {
        title: 'USDA RUCA Rural Areas',
        analysisType: 'Proximity',
        fields: [
          { key: 'county_fips', displayName: 'COUNTY_FIPS' },
          { key: 'fips', displayName: 'FIPS' },
          {
            key: 'land_area__square_miles___2010',
            displayName: 'Land Area (square miles), 2010',
          },
          { key: 'pop20_sqmi', displayName: 'POP20_SQMI' },
          { key: 'pop_sqmi', displayName: 'POP22_SQMI' },
          {
            key: 'population_density__per_square_',
            displayName: 'Population Density (per square mile), 2010',
          },
          { key: 'population_2020', displayName: 'POPULATION_2020' },
          { key: 'population', displayName: 'POPULATION_2022' },
          {
            key: 'primary_ruca_code_2010',
            displayName: 'Primary RUCA Code 2010',
          },
          {
            key: 'secondary_ruca_code__2010__see_',
            displayName: 'Secondary RUCA Code, 2010 (see errata)',
          },
          { key: 'select_county', displayName: 'Select County' },
          { key: 'select_state', displayName: 'Select State' },
          { key: 'shape__area', displayName: 'SHAPE__Area' },
          { key: 'shape__length', displayName: 'SHAPE__Length' },
          { key: 'sqmi', displayName: 'SQMI' },
          { key: 'state_abbr', displayName: 'STATE_ABBR' },
          { key: 'state_fips', displayName: 'STATE_FIPS' },
          {
            key: 'state_county_fips_code',
            displayName: 'State-County FIPS Code',
          },
          {
            key: 'state_county_tract_fips_code__l',
            displayName:
              'State-County-Tract FIPS Code (lookup by address at http://www#ff',
          },
          { key: 'stcofips', displayName: 'STCOFIPS' },
          {
            key: 'tract_population__2010',
            displayName: 'Tract Population, 2010',
          },
          { key: 'tract_fips', displayName: 'TRACT_FIPS' },
        ],
      },
    ],
  },
];
